import React from 'react';
import { Container, Stack, Text, Title, Paper, Box } from '@mantine/core';
import { IconCheck, IconMail } from '@tabler/icons-react';

const DoiConfirmationPage: React.FC = () => {
  return (
    <Container size="md" py={80}>
      <Paper shadow="md" radius="lg" p={40} withBorder>
        <Stack gap="xl" align="center">
          {/* Success Icon */}
          <Box
            style={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #51cf66 0%, #40c057 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <IconCheck size={40} color="white" stroke={2.5} />
          </Box>

          {/* Main Heading */}
          <Title order={1} ta="center" size="h2" fw={700}>
            Vielen Dank für Ihre Anmeldung!
          </Title>

          {/* Confirmation Message */}
          <Text size="lg" ta="center" c="dimmed" maw={500}>
            Ihre E-Mail-Adresse wurde erfolgreich bestätigt.
          </Text>

          {/* Newsletter Generation Info */}
          <Stack gap="md" align="center">
            <Box
              style={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <IconMail size={28} color="white" stroke={2} />
            </Box>

            <Text size="lg" ta="center" fw={600}>
              Newsletter wird generiert
            </Text>

            <Text size="md" ta="center" c="dimmed" maw={450}>
              Unsere KI stellt gerade Ihren persönlichen Newsletter zusammen – individuell auf Sie
              zugeschnitten.
            </Text>

            <Text size="md" ta="center" c="dimmed" maw={450}>
              Sie erhalten ihn in Kürze per E-Mail. Dieser Vorgang kann ein paar Minuten dauern.
            </Text>
          </Stack>

          {/* Feedback Link */}
          <Text size="md" ta="center" c="dimmed" mt="lg">
            Wir freuen uns über Ihr{' '}
            <Text
              component="a"
              href="https://forms.office.com/pages/responsepage.aspx?id=wluSDcsxCkKjXiW8m8X8vajr0sfbwL1NjNiYbK8v1jZUNlFEVkZPMjdERVVEU09NMTFVRzQwTVBKWS4u&route=shorturl"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#667eea',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Feedback
            </Text>{' '}
            zu unserem Newsletter-Service!
          </Text>
        </Stack>
      </Paper>
    </Container>
  );
};

export default DoiConfirmationPage;
